import dayjs from 'dayjs';

const datetime = (datetimeString: string) : string => (
    dayjs(datetimeString).format('DD/MM/YYYY @ HH:MM')
);

export default {
    datetime,
};
